// Screen-local atom — mockup TenantLogo'nun token-safe portu (panel/
// Shell.jsx). Deterministic per-tenant renkli kare + baş harfler; raw
// hex yerine spec-44 ramp token'larından sabit bir palet kullanır.
//
// packages/components ADAYI (missing_atoms): birden çok ops ekranı
// tüketiyor; batch kuralı gereği packages/* dokunulmadı, ekran-yerel
// yazıldı. Atom terfi ettiğinde bu dosya silinip import değişir.

const TONE_CLASSES = [
  "bg-[var(--color-accent-600)]",
  "bg-[var(--color-info-500)]",
  "bg-[var(--color-warning-600)]",
  "bg-[var(--color-danger-600)]",
  "bg-[var(--color-neutral-700)]",
  "bg-[var(--color-accent-800)]",
  "bg-[var(--color-info-700)]",
  "bg-[var(--color-neutral-900)]",
] as const;

function hashName(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return h;
}

function initialsOf(name: string): string {
  return name
    .split(/[\s.&-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export interface TenantMarkProps {
  readonly name: string;
  readonly size?: number;
}

export function TenantMark({ name, size = 32 }: TenantMarkProps): React.ReactElement {
  const tone = TONE_CLASSES[hashName(name) % TONE_CLASSES.length];
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center rounded-[7px] font-sans font-semibold tracking-[-0.02em] text-[var(--color-neutral-50)] ${tone}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {initialsOf(name)}
    </span>
  );
}
